import React from 'react';
import { Quote } from 'lucide-react';
import { ambedkarSection } from '../data/mock';

const AmbedkarSection = () => {
  return (
    <section id="ambedkar" className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-orange-500 rounded-2xl transform rotate-3"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                <img 
                  src={ambedkarSection.image} 
                  alt="Buddha Statue" 
                  className="w-full h-[500px] object-cover"
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div className="inline-block px-4 py-2 bg-blue-100 rounded-full">
              <span className="text-sm font-semibold text-blue-700">The Visionary</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
              {ambedkarSection.title}
            </h2>

            <p className="text-xl font-semibold text-blue-600">
              {ambedkarSection.subtitle}
            </p>

            <p className="text-lg text-gray-700 leading-relaxed">
              {ambedkarSection.content}
            </p>

            {/* Quote Box */}
            <div className="relative bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6 rounded-xl shadow-lg">
              <Quote className="absolute top-4 left-4 w-8 h-8 opacity-30" />
              <p className="text-lg italic pl-12 pr-4">
                "{ambedkarSection.quote}"
              </p>
              <p className="text-sm text-blue-200 mt-3 pl-12">
                - Babasaheb Dr. B.R. Ambedkar
              </p>
            </div>

            {/* Key Contributions */}
            <div className="grid grid-cols-2 gap-4 pt-4">
              <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-blue-600">
                <p className="text-2xl font-bold text-blue-600">1891</p>
                <p className="text-sm text-gray-600">Born</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-md border-l-4 border-yellow-500">
                <p className="text-2xl font-bold text-yellow-600">1956</p>
                <p className="text-sm text-gray-600">Embraced Buddhism</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AmbedkarSection;
